/**
 * ver 0.1
 * author jack
 * created 18-12-10
 */
import React from 'react'
import LoadScript from './load_script'

class ShareLayer extends React.Component {
    constructor(props) {
        super(props)
        let titleP = props.title
        let descriptionP = props.description
        let imageP = props.image
        let urlP = props.url
        let idx_cat_evt = props.idx_cat_evt
        if (titleP === undefined) titleP = '쇼핑 큐레이션 · 행복쇼핑'
        if (descriptionP === undefined)
            descriptionP =
                '행복쇼핑은 컴퓨터, 조립PC에 특화된 온라인 견적 가격비교 사이트 입니다. 안전구매시스템(전자보증,에스크로)을 갖춘 쇼핑몰, 미니샵의 최저 가격 정보를 보여드립니다. 쇼핑의 행복! 행복쇼핑'
        if (imageP === undefined) imageP = `${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${idx_cat_evt}/img_sns/fb_1200_625.jpg`
        if (urlP === undefined) urlP = window.location.href
        this.state = {
            title: titleP,
            description: descriptionP,
            imageUrl: imageP,
            url: urlP,
            copyUrl: false,
            idx_cat_evt: idx_cat_evt,
        }
    }

    componentDidMount() {
        LoadScript('https://developers.kakao.com/sdk/js/kakao.min.js').then(() => {
            window.Kakao.init('d98008c5b7924c032845dea5e5d12b26')
            // window.Kakao.init('4fd5b6d209ccbfe6ee7fd3b00bb490ef')
        })
    }

    snsKakaoTalk() {
        // document.getElementById('og_image').setAttribute('content', `${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${this.state.idx_cat_evt}/img_sns/kakao_800_400.jpg`);

        window.Kakao.Link.sendDefault({
            objectType: 'feed',
            content: {
                title: this.state.title,
                description: this.state.description,
                imageUrl: `${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${this.state.idx_cat_evt}/img_sns/kakao_800_400.jpg`,
                imageWidth: 800,
                imageHeight: 400,
                link: {
                    mobileWebUrl: this.state.url,
                    webUrl: this.state.url,
                },
            },
            buttons: [
                {
                    title: '행복쇼핑에서 보기',
                    link: {
                        mobileWebUrl: this.state.url,
                        webUrl: this.state.url,
                    },
                },
            ],
        })
    }

    snsKakaoStory() {
        // document.getElementById('og_image').setAttribute('content', `${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${this.state.idx_cat_evt}/img_sns/fb_1200_625.jpg`);
        window.open(
            `https://story.kakao.com/share?url=${this.state.url}`,
            'snsPop',
            'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=500,height=600',
        )
    }

    snsFaceBook() {
        // document.getElementById('og_image').setAttribute('content', `${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${this.state.idx_cat_evt}/img_sns/fb_1200_625.jpg`);
        // const _url = this.state.url.replace('event', 'event1')
        const _url = this.state.url
        window.open(
            `http://www.facebook.com/sharer/sharer.php?u=${_url}`,
            'snsPop',
            'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=500,height=600',
        )
    }

    snsLine() {
        //this.setState({ imageUrl: `${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${this.state.idx_cat_evt}/img_sns/fb_1200_625.jpg` })
        // document.getElementById('og_image').setAttribute('content', `${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${this.state.idx_cat_evt}/img_sns/fb_1200_625.jpg`);
        const text = encodeURIComponent(this.state.title)
        window.open(
            `http://line.me/msg/text/?${text} : ${this.state.url}`,
            'snsPop',
            'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=600,height=500',
        )
    }

    snsTwitter() {
        // document.getElementById('og_image').setAttribute('content', `${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${this.state.idx_cat_evt}/img_sns/kakao_800_400.jpg`);
        //this.setState({ imageUrl: `${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${this.state.idx_cat_evt}/img_sns/kakao_800_400.jpg` })
        const text = encodeURIComponent(this.state.title)
        window.open(
            `//twitter.com/share?text=${text}&url=${this.state.url}`,
            'snsPop',
            'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=650,height=500',
        )
    }

    copyUrl() {
        const url = document.querySelector('#copyurl')
        url.select()
        document.execCommand('Copy')
        this.setState({ copyUrl: true })
    }

    render() {
        return (
            <React.Fragment>
                <table id="lyrPop" className="bgdark">
                    <tbody>
                        <tr>
                            <td>
                                <div className="PopMain shareSnsPop">
                                    <strong className="popName">공유하기</strong>
                                    <div className="shareSnsList">
                                        <button type="button" onClick={() => this.snsKakaoTalk()}>
                                            <img
                                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_kakaotalk.png`}
                                                alt="카카오톡"
                                            />
                                            <span>카카오톡</span>
                                        </button>
                                        <button type="button" onClick={() => this.snsLine()}>
                                            <img
                                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_line.png`}
                                                alt="라인"
                                            />
                                            <span>라인</span>
                                        </button>
                                        <button type="button" onClick={() => this.snsFaceBook()}>
                                            <img
                                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_facebook.png`}
                                                alt="페이스북"
                                            />
                                            <span>페이스북</span>
                                        </button>
                                        <button type="button" onClick={() => this.snsKakaoStory()}>
                                            <img
                                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_kakaostory.png`}
                                                alt="카카오스토리"
                                            />
                                            <span>카카오스토리</span>
                                        </button>
                                        <button type="button" onClick={() => this.snsTwitter()}>
                                            <img
                                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_twitter.png`}
                                                alt="트위터"
                                            />
                                            <span>트위터</span>
                                        </button>
                                    </div>
                                    <div className="shareUrl">
                                        <input
                                            type="text"
                                            id="copyurl"
                                            className="copyurl"
                                            readOnly=""
                                            defaultValue={this.state.url}
                                        />
                                        <button type="button" className="btn_urlcopy" onClick={() => this.copyUrl()}>
                                            URL복사
                                        </button>
                                        {this.state.copyUrl && <b>URL이 복사되었습니다.</b>}
                                    </div>
                                    <div className="popDefBtns">
                                        <button type="button" className="icon-X_close" onClick={this.props.onClose} />
                                        <button type="button" className="confBtn" onClick={this.props.onClose}>
                                            확인
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </React.Fragment>
        )
    }
}

export default ShareLayer
